import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const PRODUCT_SCHEMA = [
  { key: "id", label: "Product ID", type: "string" as const },
  { key: "name", label: "Product Name", type: "string" as const },
  { key: "image", label: "Image", type: "image" as const },
  { key: "originalPrice", label: "Original Price", type: "number" as const },
  { key: "salePrice", label: "Sale Price", type: "number" as const },
  { key: "discount", label: "Discount %", type: "number" as const },
];

export const schema: ComponentSchema = {
  type: "flash-sale",
  label: "Flash Sale",
  description: "Countdown timer with a horizontal product row for time-limited offers.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Countdown + Product Row",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Flash Sale" },
        { key: "endDate", label: "Sale End Date (ISO)", type: "string", placeholder: "2025-12-31T23:59:59" },
        { key: "bgColor", label: "Header Background Color", type: "color", default: "#1a1a2e" },
        { key: "products", label: "Products", type: "array", itemSchema: PRODUCT_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
